import React, { Fragment, useContext } from 'react'
import retry from "async-retry"
import { useLocation } from 'react-router-dom'

import Constants from '../config.js'
import { AppLoadContext } from "../App.js"
import { Spaces } from "../components/Spaces"
import RunContext from '../Contexts/RunContext.js'
import { Slide } from "../display_wallet.js"
import { UserContext } from "../Contexts/UserContext/UserContext.js"
import { ButtonPrimaryOutlined } from '../components/Buttons.js'
import useLog from '../hooks/useLog.js'
import ButtonParam from './Slide_Settings/ButtonParam.js'
import SectionBackupPassword from './Slide_Settings/SectionBackupPassword.js'
import SectionDeviceSecurity from './Slide_Settings/SectionDeviceSecurity.js'
import SectionLoadToken from './Slide_Settings/SectionLoadToken.js'
import SectionCache from './Slide_Settings/SectionCache.js'
import SectionLogs from './Slide_Settings/SectionLogs.js'
import SectionBlockchainSync from './Slide_Settings/SectionBlockchainSync.js'
import SectionFirewall from './Slide_Settings/SectionFirewall.js'


/**
 * used to inject multiple contexts as props
 */
const Slide_Settings = (props) => {
	const runContext = useContext(RunContext)
	const appLoadContext = useContext(AppLoadContext)
	const userContext = useContext(UserContext)
	const location = useLocation()

	// Pass the hash to SectionBackupPassword so it can auto-open the
	// change-password popup when navigated from the weak-password banner.
	const autoOpenChangePassword = (location.hash === "#change_password")

	return (
		<Slide_Settings_inner
			userContext={userContext}
			runContext={runContext}
			appLoadContext={appLoadContext}
			autoOpenChangePassword={autoOpenChangePassword}
			{...props}
		/>
	)
}

export default Slide_Settings


/**
 * Orchestrator — loads the Run instance (via retry in componentDidMount),
 * then renders each settings section as a self-contained component.
 */
class Slide_Settings_inner extends React.PureComponent {

	static contextType = UserContext

	constructor(props) {
		super(props)
		this.classname = "Slide_Settings: "

		this.userContext = props.userContext
		this.runContext = props.runContext
		this.appLoadContext = props.appLoadContext
		this.run = null
	}

	async componentDidMount() {
		const function_id = this.classname + "componentDidMount(): "

		await retry(async () => {
			console.log(function_id + "this.runContext.get_run_asyncf()...")
			this.run = await this.runContext.get_run_asyncf()
			console.log(function_id + " successfully got run instance from context.")
		}, {
			retries: 3,
			minTimeout: 500,
			maxTimeout: 5000,
			factor: 2,
		})
		this.forceUpdate()
	}

	render() {
		const wallet_card_jsx = (
			<Fragment>
				<div className="walletcard" id="menu_tab_0"
					style={{
						justifyContent: "center", display: "flex", flexDirection: "column",
						fontSize: "20px", padding: "0.6em 0.5em",
					}}>
					<div className="badge badge-light"
						style={{ padding: "1em 0em", whiteSpace: "normal", wordBreak: "break-all" }}>
						{this.context.walletname}
					</div>
				</div><br />
			</Fragment>
		)

		const ReloadWalletButton = () => {
			const appLoadContext = useContext(AppLoadContext)
			const log = useLog("ReloadWalletButton")
			const isloading = appLoadContext.isloading
			log("RELOAD BUTTON isloading :", isloading)
			return (
				<ButtonParam
					onClick={appLoadContext.reload}
					disabled={isloading}
					style={{
						backgroundColor: isloading ? 'grey' : '',
						cursor: isloading ? 'not-allowed' : 'pointer',
						margin: "0 auto",
					}}
				>
					Reload Wallet &nbsp;
					<i className={"fas fa-sync " + (isloading ? "fa-spin" : "")} />
				</ButtonParam>
			)
		}

		return (
			<Slide num={this.props.num}>
				<h1><i className="fas fa-cog" /><Spaces count="3" />
					Wallet Settings
				</h1>
				<br />

				{wallet_card_jsx}
				<br />

				{/* --- Sections --- */}
				<SectionBackupPassword autoOpenChangePassword={this.props.autoOpenChangePassword} />
				<SectionDeviceSecurity />
				<SectionLoadToken run={this.run} />
				<SectionCache run={this.run} />
				<SectionLogs logpath={this.props.logpath} />
				<SectionBlockchainSync run={this.run} />
				<SectionFirewall run={this.run} appLoadContext={this.appLoadContext} />

				<br />

				<center>
					<ReloadWalletButton />
				</center>
				<br />

				<center>
					<ButtonPrimaryOutlined
						onClick={() => { window.open("https://t.me/+xvrPdKLAkU80ZDg8", "_blank") }}
						style={{ borderRadius: "10em", padding: "1px 15px" }}
					>
						Report a bug or get help
					</ButtonPrimaryOutlined>
				</center>
				<br />

				<div className="centered" style={{ color: "lightslategrey" }}>
					version: {Constants.APP_VERSION}
				</div>
				<br />

			</Slide>
		)
	}
}
